import appApi from '../../../../../api/app-api';
import { LecturesSideBarFilterDatamodel } from '../side-bar-filter/lectures-side-bar-filter-datamodel';
import { ReportLecturesType } from '../../../../../api/types/reports/education/report-lectures.type';
import { displayErrorText } from '../../../../../api/errors/api-error-codes';
import { toast } from 'react-toastify';

export const getLecturesReportData = async (
  filters: LecturesSideBarFilterDatamodel,
  offset: number,
  limit: number,
  setLoading: (loading: boolean) => any,
  setData: (data: ReportLecturesType[]) => any,
  setTotal: (total: number) => any,
) => {
  try {
    setLoading(true);
    if (!filters.lectureDateStart || !filters.lectureDateEnd) {
      toast.warn('יש לבחור טווח תאריכים מלא (מתאריך ועד תאריך)');
      setLoading(false);
      return;
    }
    const res = await appApi.getLecturesReport({
      branchesIds: filters.branchesIds,
      abstractProgramIds: filters.programIds,
      programsStartYears: filters.startYears,
      lectureState: filters.statuses,
      dateRangeStart: filters.lectureDateStart,
      dateRangeEnd: filters.lectureDateEnd,
      exceptionThresholdMinMinutes: filters.exceptionThresholdMinMinutes,
      exceptionThresholdMaxMinutes: filters.exceptionThresholdMaxMinutes,
      offset,
      limit,
    });
    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return;
    }
    // backend returns a paginated object: { data, total, offset, limit }
    const rows = (res.data.body?.data ?? []) as any[];
    setTotal(res.data.body?.total ?? 0);
    setData(
      rows.map((r) => ({
        // normalize casing coming from backend
        workingHoursId: r.workingHoursId ?? null,
        branchId: r.branchId ?? r.branchid,
        branchName: r.branchName,
        abstractProgramId: r.abstractProgramId ?? r.abstractprogramid,
        abstractProgramName: r.abstractProgramName,
        abstractProgramYears: r.abstractProgramYears,
        programId: r.programId,
        annualSerialProgramNumber: r.annualSerialProgramNumber,
        programStartYear: r.programStartYear,
        programStatus: r.programStatus,
        notes: r.notes ?? null,
        additionalProgramName: r.additionalProgramName ?? null,

        abstractCourseId: r.abstractCourseId,
        courseName: r.courseName,
        courseHours: r.courseHours,
        attendancePercentage: r.attendancePercentage,
        courseId: r.courseId,
        status: r.status,
        courseStartDate: r.courseStartDate ? new Date(r.courseStartDate) : null,
        additionalCourseName: r.additionalCourseName ?? null,

        uid: r.uid ?? r.userId,
        firstName: r.firstName ?? r.userFirstName,
        lastName: r.lastName ?? r.userLastName,
        nationalId: r.nationalId,
        phoneNumber: r.phoneNumber,
        email: r.email,

        startAtActualTime: r.startAtActualTime
          ? new Date(r.startAtActualTime)
          : null,
        endAtActualTime: r.endAtActualTime ? new Date(r.endAtActualTime) : null,
        scheduledStartTime: r.scheduledStartTime
          ? new Date(r.scheduledStartTime)
          : null,
        scheduledEndTime: r.scheduledEndTime
          ? new Date(r.scheduledEndTime)
          : null,
        minutesExceeded: r.minutesExceeded ?? null,
      })),
    );
    setLoading(false);
  } catch (e) {
    setLoading(false);
  }
};
